import React from 'react';
import { injectIntl } from 'react-intl';
import { TextField, IconButton, Button } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import DeleteIcon from '@mui/icons-material/Delete';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { isMobile } from 'react-device-detect';
import './TemplateEditor.scss';

const styles = {
  inputBase: {
    fontSize: 'inherit'
  },
  input: {
    height: '15px',
    fontSize: 15
  },
  inputLabel: {
    transform: 'translate(14px, 12px) scale(1)',
    '&.MuiInputLabel-shrink': {
      transform: 'translate(14px, -9px) scale(0.75)'
    }
  }
};

class TemplateEditor extends React.PureComponent {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = {
      template: props.template.template,
      important: props.template.important
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.focus && this.props.focus) {
      this.ref.current.focus();
    } else if (!this.props.submit && prevProps.submit) {
      //reset fields for adding new template
      this.setState({
        template: this.props.template._id ? this.props.template.template : '',
        important: this.props.template._id ? this.props.template.important : false
      });
    }
  }

  handleClose = () => {
    this.props.closeEditor();
    this.setState({
      template: this.props.template._id ? this.props.template.template : '',
      important: this.props.template._id ? this.props.template.important : false
    });
  };

  handleKeyPress = e => {
    if (e.key === 'Enter' && !e.shiftKey && !isMobile) {
      e.preventDefault();
      this.onSubmit();
    }
  };

  onSubmit = () => {
    if (
      this.state.template === this.props.template.template &&
      this.state.important === this.props.template.important &&
      this.props.template._id
    ) {
      this.props.closeEditor();
      return;
    }
    let newTemplate = {
      ...this.props.template,
      template: this.state.template,
      important: this.state.important
    };
    this.props.onSave();
    if (!this.props.template._id) {
      this.props.addAdviserTemplate({ template: newTemplate });
    } else {
      this.props.updateAdviserTemplate({ template: newTemplate });
    }
  };

  setImportant = () => this.setState({ important: !this.state.important });

  onDelete = () => this.props.deleteAdviserTemplate({ templateId: this.props.template._id.toString() });

  render() {
    return (
      <div className="editor-container">
        <TextField
          onChange={e => this.setState({ template: e.target.value })}
          multiline={true}
          inputRef={this.ref}
          label={
            this.props.template._id
              ? this.props.intl.formatMessage({ id: 'update-template' })
              : this.props.intl.formatMessage({ id: 'add-template' })
          }
          variant="outlined"
          disabled={this.props.submit}
          onKeyPress={this.handleKeyPress}
          value={this.state.template}
          slotProps={{
            input: {
              classes: {
                root: this.props.classes.inputBase,
                input: this.props.classes.input
              }
            },
            inputLabel: { className: this.props.classes.inputLabel }
          }}
        />
        <div className="star">
          <div className="star-field" onClick={this.setImportant}>
            {this.state.important && <StarIcon className="checked" />}
            {!this.state.important && <StarBorderIcon className="unchecked" />}
            <div className="star-text">{this.props.intl.formatMessage({ id: 'Pin to top' })}</div>
          </div>
        </div>
        <div className={'save-and-cancel' + (this.props.template._id ? '' : ' no-delete')}>
          {this.props.template._id && (
            <IconButton
              edge="end"
              aria-label="delete"
              disabled={this.props.submit}
              onClick={this.props.onDelete}
              size="large"
            >
              <DeleteIcon />
            </IconButton>
          )}
          <div>
            <Button disabled={this.props.submit} onClick={this.handleClose}>
              {this.props.intl.formatMessage({ id: 'Cancel' })}
            </Button>
            <Button disabled={this.props.submit} onClick={this.onSubmit}>
              {this.props.intl.formatMessage({ id: this.props.template._id ? 'Save' : 'Submit' })}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(withStyles(TemplateEditor, styles));
